import { render, staticRenderFns } from "./RichTextBoxInputMethodSelector.vue?vue&type=template&id=6c6d9f5d&scoped=true&"
import script from "./RichTextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./RichTextBoxInputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d9f5d",
  null
  
)

export default component.exports